/**
 * Open-box / outlet products: require agreement checkbox before add-to-cart.
 * Uses event delegation so quick-add modal (AJAX-loaded product HTML) works.
 */
(function () {
  const DEFAULT_REMIND = 'Please check the necessary options first';
  const DEFAULT_CHECKBOX_HTML =
    'I agree to the item is not eligible for exchange or return.<br>Ship to USA only. Final Sale. 6-month Warranty.';

  const getScope = (el) =>
    el.closest('product-info') ||
    el.closest('.quick-add-modal__content-info') ||
    el.closest('quick-add-modal') ||
    null;

  const isOpenBoxScope = (scope) => {
    if (!scope) return false;
    const info = scope.matches?.('product-info') ? scope : scope.closest('product-info');
    if (info?.getAttribute('data-openbox-required') === 'true') return true;
    return Boolean(scope.querySelector('.cannot_buy, [data-open-box-purchase-tips]'));
  };

  const mountTipsInCannotBuy = (scope) => {
    const tips = scope.querySelector('[data-open-box-purchase-tips]');
    const wrap = scope.querySelector('.cannot_buy');
    if (!tips || !wrap || wrap.contains(tips)) return;
    wrap.insertBefore(tips, wrap.firstChild);
  };

  const ensureOpenBoxUI = (scope) => {
    if (!scope || !isOpenBoxScope(scope)) return;
    mountTipsInCannotBuy(scope);

    if (!scope.querySelector('.checkto_addproduct')) {
      let wrap = scope.querySelector('.cannot_buy');
      if (!wrap) {
        const productForm = scope.querySelector('product-form');
        const formHost =
          productForm?.parentElement ||
          scope.querySelector('.product__info-container');
        if (!productForm || !formHost) return;
        wrap = document.createElement('div');
        wrap.className = 'cannot_buy';
        wrap.id = `btn-box-${scope.dataset.productId || 'openbox'}`;
        wrap.appendChild(productForm);
        formHost.appendChild(wrap);
      }

      const tips = document.createElement('div');
      tips.className = 'purchase_tips';
      tips.setAttribute('data-open-box-purchase-tips', '');
      tips.innerHTML = `
        <div class="remind_text">${DEFAULT_REMIND}</div>
        <label class="openboxtag">
          <span class="tips_checkbox">
            <input type="checkbox" class="checkto_addproduct" aria-label="${DEFAULT_REMIND}">
          </span>
          <span class="checkbox_text">${DEFAULT_CHECKBOX_HTML}</span>
        </label>`;
      wrap.insertBefore(tips, wrap.firstChild);
    }
  };

  const setAgreed = (scope, agreed) => {
    if (!scope || !isOpenBoxScope(scope)) return;
    ensureOpenBoxUI(scope);

    const toggle = scope.querySelector('.checkto_addproduct');
    const remind = scope.querySelector('.remind_text');
    const forms = scope.querySelectorAll('.cannot_buy .product-form, product-form.not_buy');

    if (toggle) {
      if (toggle.type === 'checkbox') {
        toggle.checked = agreed;
      }
      toggle.classList.toggle('check_right', agreed);
      toggle.setAttribute('aria-pressed', agreed ? 'true' : 'false');
    }
    if (remind) remind.style.display = agreed ? 'none' : '';

    forms.forEach((form) => {
      form.classList.toggle('not_buy', !agreed);
      form.querySelectorAll('.product-form__submit, .shopify-payment-button button').forEach((btn) => {
        if (agreed) {
          btn.removeAttribute('aria-disabled');
          if (btn.classList.contains('product-form__submit') && btn.hasAttribute('data-was-disabled')) {
            btn.disabled = btn.getAttribute('data-was-disabled') === 'true';
            btn.removeAttribute('data-was-disabled');
          }
        } else if (btn.classList.contains('product-form__submit')) {
          if (!btn.hasAttribute('data-was-disabled')) {
            btn.setAttribute('data-was-disabled', btn.disabled ? 'true' : 'false');
          }
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    });
  };

  const initOpenBoxPurchase = (root) => {
    const container = root && root.nodeType === 1 ? root : document;
    const scopes = new Set();

    const rootInfo =
      container.matches?.('product-info') ? container : container.closest?.('product-info');
    if (rootInfo?.getAttribute('data-openbox-required') === 'true') {
      scopes.add(rootInfo);
    }

    container.querySelectorAll('.cannot_buy, [data-open-box-purchase-tips]').forEach((node) => {
      const scope = getScope(node);
      if (scope) scopes.add(scope);
    });

    scopes.forEach((scope) => {
      ensureOpenBoxUI(scope);
      const toggle = scope.querySelector('.checkto_addproduct');
      const agreed =
        toggle?.type === 'checkbox' ? toggle.checked : toggle?.classList.contains('check_right');
      setAgreed(scope, Boolean(agreed));
    });
  };

  document.addEventListener(
    'change',
    (e) => {
      if (!e.target.matches('.checkto_addproduct[type=checkbox]')) return;
      const scope = getScope(e.target);
      if (!isOpenBoxScope(scope)) return;
      setAgreed(scope, e.target.checked);
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('button.checkto_addproduct');
      if (!btn) return;
      const scope = getScope(btn);
      if (!isOpenBoxScope(scope)) return;
      e.preventDefault();
      e.stopPropagation();
      setAgreed(scope, !btn.classList.contains('check_right'));
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const wrap = e.target.closest('.cannot_buy');
      if (!wrap) return;
      if (e.target.closest('.checkto_addproduct, .purchase_tips, .openboxtag, [data-open-box-purchase-tips]')) {
        return;
      }

      const scope = getScope(wrap);
      if (!scope) return;

      const remind = scope.querySelector('.remind_text');
      if (!remind) return;

      const toggle = scope.querySelector('.checkto_addproduct');
      const agreed =
        toggle?.type === 'checkbox' ? toggle.checked : toggle?.classList.contains('check_right');
      remind.style.display = agreed ? 'none' : '';
    },
    true
  );

  window.initOpenBoxPurchase = initOpenBoxPurchase;

  document.addEventListener('DOMContentLoaded', () => initOpenBoxPurchase(document));
})();
